import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Candidate from '../../jobs/jobDetails/candidateListModal/candidate'
import { CandidateWrapper } from '../../jobs/jobDetails/styles'

const CandidateBlock = styled.div`
  display: flex;
  flex-direction: column;
  button {
    width: fit-content;
    padding: 10px 15px;
    margin: 0 0 0 2rem;
  }
`

export const ClientShortlist = ({ shortlist, clients, setShortlist }) => {
  const updateSelection = (candidate, selection, setSelection) => {
    let check = false
    selection.map(n => {
      if (n.id === candidate.id) {
        check = true
      }
      return n
    })
    if (check) {
      setSelection(selectedCandidateList =>
        selectedCandidateList.filter(
          selectedCandidate => selectedCandidate !== candidate,
        ),
      )
    } else {
      setSelection([...selection, candidate])
    }
  }
  return (
    <>
      {clients?.length !== 0 ? (
        <>
          <h3>Client list</h3>
          <CandidateWrapper>
            {clients?.map(candidate => (
              <CandidateBlock key={candidate.id}>
                <Candidate
                  id={candidate.id}
                  jobTitle={candidate.type}
                  name={`${candidate.name}`}
                  onChange={() =>
                    updateSelection(candidate, shortlist, setShortlist)
                  }
                  value={shortlist
                    .map(selectedCandidate => selectedCandidate.id)
                    .includes(candidate.id)}
                  status={candidate.status}
                  action="select"
                  isClient={true}
                />
              </CandidateBlock>
            ))}
          </CandidateWrapper>
        </>
      ) : null}
    </>
  )
}

ClientShortlist.defaultProps = {
  shortlist: [],
  clients: [],
}

ClientShortlist.propTypes = {
  shortlist: PropTypes.array,
  clients: PropTypes.array,
  setShortlist: PropTypes.func.isRequired,
}
